export default __webpack_public_path__ + "static/media/dulce.226384dc.png";